<template>
  <page-news-layout>
    <div>
      <h2>{{ $t("about_us_news_right_flex_one") }}</h2>
    </div>
    <div v-for="(c, index) in content" :key="c">
      <div v-if="index == 5">
        <p>
          {{ $t(c.p) }}
        </p>
      </div>
      <div v-else>
        <p>
          {{ $t(c.p) }}
        </p>
        <h4>{{ $t(c.h) }}</h4>
      </div>
    </div>
    <div class="mt-5 mb-5">
      <base-link-button link="/about"></base-link-button>
    </div>
  </page-news-layout>
</template>
<script>
import BaseLinkButton from "@/components/BaseLinkButton.vue"
import PageNewsLayout from "@/components/PageNewsLayout.vue"
export default {
  components: { BaseLinkButton, PageNewsLayout },
  name: "Entreprenuor",
  data() {
    return {
      chips: [{ chip: "#preduzetnistvo" }],

      content: [
        { p: "entrepeneur_p1", h: "entrepeneur_h1" },
        { p: "entrepeneur_p2", h: "entrepeneur_h2" },
        { p: "entrepeneur_p3", h: "entrepeneur_h3" },
        { p: "entrepeneur_p4", h: "entrepeneur_h4" },
        { p: "entrepeneur_p5", h: "entrepeneur_h5" },
        { p: "entrepeneur_p6" }
      ]
    }
  }
}
</script>
